// Web Google Sign-In via Google Identity Services (GIS), using YOUR OWN Google
// Web Client ID — so the consent screen shows "GrowDaily" and the user stays on
// your site (no Emergent redirect). GIS returns a signed idToken (credential)
// which is verified server-side at POST /api/auth/google-native — the SAME
// endpoint the native app uses. Native app keeps using the @capgo plugin.
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID;

let gisPromise = null;

export function gisAvailable() {
    return !!WEB_CLIENT_ID;
}

function loadGis() {
    if (gisPromise) return gisPromise;
    gisPromise = new Promise((resolve, reject) => {
        if (window.google?.accounts?.id) return resolve(window.google);
        const s = document.createElement('script');
        s.src = 'https://accounts.google.com/gsi/client';
        s.async = true;
        s.defer = true;
        s.onload = () => resolve(window.google);
        s.onerror = () => reject(new Error('Failed to load Google Identity Services'));
        document.head.appendChild(s);
    });
    return gisPromise;
}

/**
 * Render the official Google Sign-In button into `buttonEl`. On success the
 * callback receives the idToken (credential) to POST to the backend.
 */
export async function initGoogleButton(buttonEl, onCredential) {
    if (!WEB_CLIENT_ID) throw new Error('Missing REACT_APP_GOOGLE_WEB_CLIENT_ID');
    const google = await loadGis();
    google.accounts.id.initialize({
        client_id: WEB_CLIENT_ID,
        callback: (resp) => onCredential(resp.credential),
        ux_mode: 'popup',
        auto_select: false,
    });
    buttonEl.innerHTML = '';
    google.accounts.id.renderButton(buttonEl, {
        theme: 'filled_blue',
        size: 'large',
        shape: 'pill',
        text: 'continue_with',
        width: 320,
        logo_alignment: 'left',
    });
}
